/**
 * Converts the passed value into a non-negative CSS pixel value string
 * @param value Input value
 * @param useAuto If true, returns 'auto' instead of '0px' when value would be 0
 * @returns A valid, non-negative CSS pixel string value or 'auto' (e.g. '10px')
 */
export const convertValueToPixels = (value?: number | string | null, useAutoValue = false): string => {
  const defaultValue = useAutoValue ? 'auto' : '0px';

  const parsedValue = typeof value === 'number' ? value : parseInt(value ?? '');
  if (!isNaN(parsedValue)) {
    const nonNegativeValue = Math.max(0, parsedValue);
    return nonNegativeValue === 0 ? defaultValue : `${nonNegativeValue}px`;
  }

  return defaultValue;
};
